/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout'

const ai = {
  path: '/ai',
  component: Layout,
  redirect: '/ai/project-info',
  name: 'Ai',
  meta: {
    title: 'ai',
    icon: 'ai',
    perm: 'cSiteAiManager'
  },
  children: [
    {
      path: 'ai-box',
      component: () => import('@/layout/ComponentWrap.vue'),
      name: 'AiBox',
      meta: { title: 'aiBox', perm: 'cSiteAiBoxManager' },
      children: [
        {
          path: 'ai-box-device',
          component: () => import('@/views/ai/ai-box/ai-device/index.vue'),
          name: 'AiDevice',
          meta: { title: 'aiDevice', perm: 'cSiteAiBoxManager' }
        },
        {
          path: 'box-alarm-record',
          component: () => import('@/views/ai/ai-box/face-record/index.vue'),
          name: 'AlarmRecord',
          meta: { title: 'alarmRecord', perm: 'cSiteAiBoxManager' }
        },
        {
          path: 'box-statistical-record',
          component: () =>
            import('@/views/ai/ai-box/statistical-record/index.vue'),
          name: 'StatisticalRecord',
          meta: { title: 'statisticalRecord', perm: 'cSiteAiBoxManager' }
        }
      ]
    }
    // {
    //   path: 'face-box',
    //   component: () => import('@/layout/ComponentWrap.vue'),
    //   name: 'FaceBox',
    //   meta: { title: 'faceBox', perm: 'cSiteAiBoxManager' },
    //   children: [
    //     {
    //       path: 'face-ai-device',
    //       component: () => import('@/views/ai/face-box/ai-device/index.vue'),
    //       name: 'AiDevice',
    //       meta: { title: 'aiDevice', perm: 'cSiteAiBoxManager' }
    //     },
    //     {
    //       path: 'face-ai-record',
    //       component: () => import('@/views/ai/face-box/index.vue'),
    //       name: 'FaceRecord',
    //       meta: { title: 'faceRecord', perm: 'cSiteAiBoxManager' }
    //     },
    //     {
    //       path: 'face-statistical-record',
    //       component: () => import('@/views/ai/face-box/face-record/index.vue'),
    //       name: 'StatisticalRecord',
    //       meta: {
    //         title: 'statisticalRecord',
    //         perm: 'cSiteAiBoxManager',
    //         recordType: 'record'
    //       }
    //     }
    //   ]
    // }
    // {
    //   path: 'ai-camera',
    //   component: () => import('@/views/monitor/ai-record/index.vue'),
    //   name: 'AiCamera',
    //   meta: { title: 'aiCamera', perm: 'cSiteAiCamera' }
    // },
    // {
    //   path: 'ai-statistics',
    //   component: () => import('@/views/ai/ai-statistics/index.vue'),
    //   name: 'AiStatistics',
    //   meta: { title: 'aiStatistics', perm: 'aiTrafficStatistics' }
    // }
  ]
}
export default ai
